import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
// import { SplitText } from 'gsap/SplitText'
// import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin'

gsap.registerPlugin(ScrollTrigger)

export default class extends BaseModule {
  init() {
    const { effect } = this.el.dataset
    this[effect]()
  }

  unblur() {
    this.animated = false

    const animate = () => {
      if (this.animated) return
      gsap.fromTo(
        this.el,
        {
          filter: 'blur(40px)',
          duration: 0.7,
        },
        {
          filter: 'blur(0)',
        },
      )
      this.animated = true
    }

    ScrollTrigger.create({
      trigger: this.el,
      once: true,
      // markers: true,
      start: 'top 80%',
      end: 'bottom 20%',
      onEnter: animate,
      onEnterBack: animate,
    })
  }
}
